import { SignUp, useUser } from "@clerk/clerk-react"
import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute("/(auth)/sign-up")({
  component: RouteComponent,
})

function RouteComponent() {
  const { isSignedIn, isLoaded } = useUser()

  // Show loading state while checking authentication
  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  // Declaratively redirect if authenticated
  if (isSignedIn) {
    return <Navigate to="/app" replace />
  }

  // Show sign in if not authenticated
  return (
    <div className="flex items-center justify-center min-h-screen">
      {/* <SignInButton mode="modal" forceRedirectUrl="/app">
        <Button>Log in or sign up</Button>
      </SignInButton> */}
      <SignUp forceRedirectUrl="/app" />
    </div>
  )
}
